import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { popupAnnouncementService } from '../services';
import { resolveMediaUrl } from '../services/api';
import PageBreadcrumb from '../components/PageBreadcrumb';

const PopupAnnouncementPage = () => {
    const { slug } = useParams();
    const [announcement, setAnnouncement] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAnnouncement = async () => {
            try {
                const response = await popupAnnouncementService.getBySlug(slug);
                setAnnouncement(response.data || null);
            } catch (error) {
                setAnnouncement(null);
            } finally {
                setLoading(false);
            }
        };

        fetchAnnouncement();
    }, [slug]);

    if (loading) {
        return (
            <div className="py-20 text-center">
                <div className="inline-block h-12 w-12 animate-spin rounded-full border-b-2 border-emerald-600"></div>
            </div>
        );
    }

    if (!announcement) {
        return (
            <div className="mx-auto max-w-3xl px-4 py-20 text-center">
                <h1 className="text-3xl font-bold text-slate-900">Page Not Found</h1>
                <p className="mt-3 text-slate-600">This announcement may be inactive or unavailable.</p>
                <Link to="/" className="mt-6 inline-block rounded-lg bg-emerald-600 px-5 py-2 text-white hover:bg-emerald-700">
                    Go Home
                </Link>
            </div>
        );
    }

    return (
        <div className="bg-slate-50 py-16">
            <PageBreadcrumb
                title={announcement.title}
                description={announcement.type?.replace('_', ' ') || 'Announcement'}
                items={[{ label: 'Announcements' }, { label: announcement.title }]}
            />
            <article className="mx-auto max-w-4xl overflow-hidden rounded-2xl bg-white shadow-lg">
                {announcement.image && (
                    <img src={resolveMediaUrl(announcement.image)} alt={announcement.title} className="h-72 w-full object-cover" />
                )}
                <div className="p-8">
                    <span className="rounded-full bg-emerald-100 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-emerald-700">
                        {announcement.type?.replace('_', ' ') || 'announcement'}
                    </span>
                    <h1 className="mt-4 text-4xl font-black text-slate-900">{announcement.title}</h1>
                    <p className="mt-6 whitespace-pre-line text-lg leading-relaxed text-slate-700">{announcement.message}</p>
                    <div className="mt-8 flex flex-wrap gap-3">
                        <Link to="/" className="rounded-lg bg-slate-900 px-5 py-2 text-white hover:bg-slate-800">Back to Home</Link>
                        {announcement.cta_label && announcement.cta_url && (
                            <a href={announcement.cta_url} className="rounded-lg bg-emerald-600 px-5 py-2 text-white hover:bg-emerald-700">
                                {announcement.cta_label}
                            </a>
                        )}
                    </div>
                </div>
            </article>
        </div>
    );
};

export default PopupAnnouncementPage;
